(function () {
  // Swap the header cart icon for the theme's own little bag icon,
  // keeping the cart link, its label, and the item-count bubble intact.
  var bagSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-header-bag" viewBox="0 0 27.2 27"><path d="M19.6 9c-.2-5.1-2.7-9-6-9s-5.8 3.9-6 9h-4v18h20V9h-4zm-6-7c2.1 0 3.8 3.2 4 7h-8c.2-3.8 1.9-7 4-7zm-8 23V11h11v14h-11zm16 0h-3V11h3v14z"/></svg>';
  var links = document.querySelectorAll('.site-header__cart');
  for (var i = 0; i < links.length; i++) {
    if (links[i].querySelector('.icon-header-bag')) continue;
    var oldIcon = links[i].querySelector('svg');
    if (oldIcon) oldIcon.outerHTML = bagSvg;
  }
})();
